<template>
    <div>
        <div class="modal-container">
            <div class="is-size-5 top5 left10">
                <span class="has-text-white isPoppins"><b>Login</b></span>
                <div class="delete is-large is-pulled-right" @click="doClose"></div>
            </div>

            <div class="modal-body top20">
                <form>
                    <div class="field" >
                            Email:
                            <input type="text" class="input is-warning" name="Email" v-validate="'required|email'" v-model="email" />

                    </div>
                    <div class="field" >
                            Password:
                            <input class="input is-warning" type="password" name="Password" v-validate="{required: true}" v-model="password"/>
                    </div>

                    <div v-if="showErrMsg" class="bottom10">
                        <span class="has-text-danger">{{errMsg}}</span>
                    </div>

                    <div class="">
                        <button id="goButton" class="button is-warning  is-pulled-right " type="submit" @click.prevent="authenticate">GO</button>

                        <span class="handCursor  is-small top5" @click.prevent="forgot">Forgot Password?</span>
                    </div>
                </form>
                <div class="has-text-centered has-text-grey-light">
                    _____________________________________
                </div>

                <div class="level top20">
                    <b>&nbsp;&nbsp;&nbsp;Don't have an account?</b>
                    <button class="button is-warning"  v-on:click="doRegister">REGISTER</button>
                </div>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
export default {
  props: { message: String },
  data: function() {
    return {
      email: "",
      password: "",
      showErrMsg: true,
      errMsg: ""
    };
  },
  mounted: function() {
    if(this.$route.fullPath == '/' && this.$root.goAfterLogin == ''){
      this.$root.goAfterLogin = '/mng'
    }
  },
  methods: {
    doLogin: function() {
      // TODO remove this function after Cognito fully implemented
      //this.$root.isAuth = true;
      if (this.$root.goAfterLogin != "") {
        this.$router.push(this.$root.goAfterLogin);
        this.$root.goAfterLogin = "";
      }

      this.$emit("close");
      //
    },
    doRegister: function() {
      this.$router.push("/register");
      this.$emit("close");
    },
    doClose: function() {
      this.$root.goAfterLogin = "";
      this.$emit("close");
    },
    forgot: function() {
      this.$emit("close");
      this.$router.push("/forgot");
    },
    authenticate: function() {
      var self = this;
      this.$validator.validateAll().then(res => {
        if (res) {
          sendAuth();
        } else {
          self.errMsg = "Please provide both fields.";
          self.showErrMsg = true;
        }
      });

      function sendAuth() {
        az.addRemSpinner(true, "id", "goButton");

        self.errMsg = "";
        self.showErrMsg = false;

        self.$root.azCognito.authenticate(
          self.email.toLowerCase(),
          self.password,
          authenticateCallBack
        );

        function authenticateCallBack(result, obj) {
          az.addRemSpinner(false, "id", "goButton");
          if (result == "error") {
            if (
              obj.message == "Incorrect username or password." ||
              obj.message == "User does not exist."
            ) {
              self.errMsg = "Incorrect email or password.";
              self.showErrMsg = true;
            } else if (obj.message == "Password attempts exceeded") {
              self.errMsg =
                "Password attempts limit exceeded, please try again later.";
              self.showErrMsg = true;
            } else if (obj.code == "UserNotConfirmedException") {
              self.$router.push("/unverified");
              self.$root.userAttrs.email = self.email.toLowerCase();
              self.$emit("close");
            }
            return;
          } else if (result == "changePwd") {
            self.$emit("close");
            self.$router.push("/completereg");
            return;
          }

          //self.$root.doneFederating = false;
          self.$emit("close");
          // if conditional is true, means email is not verified:
          if (self.$root.doAuthenticated(obj, true)) {
            self.azCognito.logOutUser(null);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.modal-container {
  border-top: 8px solid #ffb227;
  width: 350px;
  height: 380px;
  border-radius: 15px;
  overflow: hidden;
  background: #000046;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #000f46, #21496b );  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #000f46, #21496b); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
</style>



// WEBPACK FOOTER //
// src/components/ModalLogin.vue